import 'core-js/stable';
import { createApp } from 'vue';
// import Vuex from 'vuex';
import Es6Promise from 'es6-promise';
import App from './App.vue';
import { THEME } from '@/components/constants';
import router from '@/router/main';
// lego components
import VueNoti from '@kyvg/vue3-notification';
import compo from '@/lego-component/components';
import direc from '@/lego-component/directives';
import filter from '@/lego-component/filters';
import legoCompoOverride from '@/components/lego/compoOverride';

// cmp components
import cmpComponent from '@/components';

// vueI18n load

import i18n from './i18n';
import restManagerInstall from '@/plugin/restManager.js';
import { restManager } from '@/plugin/restManager.js';
import constant from '@/utils/constant.js';
import commonCode from '@/utils/commonCode.js';
import scpmUtil from '@/utils/scpmUtil.js';
import cmpLogin from '@/utils/cmpLogin';
import util from '@/utils/cmpLogin/util.js';
import '@style/common.scss';
import '@/lego-component/styles/lego.scss';
import '@/assets/scpm.scss';
import moment from 'moment-timezone';

import store from '@/store';

const app = createApp(App);
app.config.globalProperties.$theme = THEME;
Es6Promise.polyfill();
// lego components
app.use(VueNoti);
// app.use(Vuex);
app.use(compo);
app.use(direc);
app.use(filter);
app.use(restManagerInstall);
app.use(scpmUtil);
app.use(commonCode);
app.use(constant);
// lego components override
legoCompoOverride(app);

// cmp components
app.use(cmpComponent);
cmpLogin
  .validateSession()
  .then((res) => {
    let languageTag = util.getLanguageTag(res);
    const userUuid = util.getUserUuid();

    const userAPI = `${process.env.VUE_APP_PROXY}/console/api/iam/v1/users/${userUuid}`;
    const promiseArr = [
      restManager.system.get('/v1/console/menus', { languageTag }, false, true),
      restManager.system.get('/v1/console/commoncodes', null, false, true),
      restManager.get(userAPI, null, false, true)
    ];

    Promise.all(promiseArr).then((data) => {
      const resError = data.find((res, index) => {
        return (
          [0, 2].includes(index) &&
          typeof res.response !== 'undefined' &&
          res.response.status === 401
        );
      });
      if (typeof resError !== 'undefined') {
        let error = resError.response.data;
        if (error === '') {
          cmpLogin.goToLogin();
        } else {
          alert(error.message);
          window.location.href = `${process.env.VUE_APP_REST_PROTOCOL}//${process.env.VUE_APP_REST_SUBDOMAIN}.${process.env.VUE_APP_REGION}.${process.env.VUE_APP_REST_DOMAIN}/console`;
        }
        return;
      }

      const [menuRes, commoncodeRes, userRes] = data;
      window.lnbData = menuRes.contents;
      window.commonCode = commoncodeRes;

      //Function for set user info to session storage
      util.setCurrentUserInfo(userRes);

      if (languageTag) restManager.setLanguageHeaders(languageTag);

      app.use(router).use(store).use(i18n);
      router.isReady().then(() => app.mount('#app'));
    });
  })
  .catch(() => {
    return;
  });

window.addEventListener(
  'focus',
  function () {
    // 세션 데이터 강제 삭제 확인시 로그아웃 처리.
    if (process.env.VUE_APP_USE_IDP == 'true' && !window.sessionStorage.getItem('userId')) {
      cmpLogin.logout();
    }

    // 역할 전환된 상태에서 원래 계정으로 복귀 했을경우에 제 리로드 처리.
    if (process.env.VUE_APP_USE_IDP == 'true') {
      cmpLogin.validateSessionExpiredChangeRole().then(() => {
        // const userId = data.userId
        // if (userId != window.sessionStorage.getItem('userId')) {
        //   util.setWindowLocation('/console/monitoring/');
        // }
      });
    }

    //프로젝트 권한이 변경될 경우 갱신된 권한으로 리로드 처리.
    // restManager.system.get('/v1/console/projects', {}, false,false).then((data) => {
    //     this.$t=i18nMixin.methods.t;
    //     if( !util.equalsIgnoreOrder(data.projects.map(p=>p.projectId),store.state.projects.map(p=>p.value))){
    //         if( typeof window.app.$modal !== 'undefined') {
    //             const close = ()=>{
    //                 if(process.env.VUE_APP_USE_IDP == 'true' ){
    //                     util.setWindowLocation('/monitoring-console/');
    //                 }else{
    //                     util.setWindowLocation('/');
    //                 }
    //             }
    //             window.app.$modal.open({
    //                 rootId: 'app',
    //                 type: 'alert',
    //                 title: this.$t('message.notice'),
    //                 message: this.$t('errorCode.ProjectAccessDenied'),
    //                 action: close,
    //                 cancel: close
    //             });
    //         }
    //     }
    // });
  },
  false
);
